module.exports = __webpack_public_path__ + "img/left-leg.b61cd7c4.png";